import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Heart } from 'lucide-react';
import { Button } from './ui/Button';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const links = [{
    name: 'Accueil',
    href: '/'
  }, {
    name: 'À Propos',
    href: '/about'
  }, {
    name: 'Nos Actions',
    href: '/actions'
  }, {
    name: 'PROMAISON',
    href: '/promaison'
  }, {
    name: 'Inscription',
    href: '/inscription'
  }, {
    name: 'Notre Vision',
    href: '/impact'
  }, {
    name: 'Blog',
    href: '/blog'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-88" data-mp="t03k1nv1immv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89" data-mp="sya8bu5klc80">
        <div className="flex justify-between h-28" data-id="element-90" data-mp="p02t53qr8iyx">
          <div className="flex items-center" data-id="element-91" data-mp="dfpg3y3en4e0">
            <Link to="/" className="flex-shrink-0 flex items-center gap-3" data-id="element-92" data-mp="dh0qigrcvae3">
              <img src="https://cdn.magicpatterns.com/uploads/qCb6hamLArrr2SMb6t4UDJ/ADCC_logo.png" alt="ADCC - Association Dignité Compétence Création" className="h-20 w-auto max-w-[250px] object-contain" data-id="element-93" data-mp="hgj2gn178b4s" />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex md:items-center md:space-x-6" data-id="element-94" data-mp="webev6bg8jer">
            {links.map(link => link.href === '/promaison' ? <Link key={link.name} to={link.href} className="relative inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold text-white shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5" style={{
            backgroundColor: '#1E3A5F'
          }} data-id="element-95" data-mp="156dex3hlvxoi">
                  {/* Pulsing attention dot */}
                  <span className="relative flex h-2.5 w-2.5" data-id="element-96" data-mp="ugiea3mz4012">
                    <span className="absolute inline-flex h-full w-full rounded-full opacity-75 animate-ping" style={{
                backgroundColor: '#D4A574'
              }} data-id="element-97" data-mp="php16cblmb1f" />
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5" style={{
                backgroundColor: '#D4A574'
              }} data-id="element-98" data-mp="zd8viuail1o2" />
                  </span>
                  {link.name}
                </Link> : <Link key={link.name} to={link.href} className={`text-sm font-medium transition-colors ${isActive(link.href) ? 'text-[#1E88E5]' : 'text-gray-600 hover:text-[#1E88E5]'}`} data-id="element-99" data-mp="1i51quvd22yyy">
                  {link.name}
                </Link>)}

            <Link to="/donate" data-id="element-100" data-mp="1zffchgjus4f5">
              <Button variant="primary" size="sm" className="gap-2" data-id="element-101" data-mp="24e0dvjaucu56">
                <Heart className="w-4 h-4" data-id="element-102" data-mp="24d72u64unih8" />
                Faire un don
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-103" data-mp="1un5erechy02b">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#1E88E5]" data-id="element-104" data-mp="1uluehoi9fafy">
              <span className="sr-only" data-id="element-105" data-mp="16scjf3xy4lwa">Open main menu</span>
              {isOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-106" data-mp="1bpl0f17cyjvy" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-107" data-mp="314skzrfsrbut" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100" data-id="element-108" data-mp="15zt907ubgtbb">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-109" data-mp="111hzxzbuimu5">
            {links.map(link => link.href === '/promaison' ? <Link key={link.name} to={link.href} onClick={() => setIsOpen(false)} className="flex items-center gap-2 px-3 py-2.5 rounded-md text-base font-bold text-white" style={{
          backgroundColor: '#1E3A5F'
        }} data-id="element-110" data-mp="wyl9xnjz7og6">
                  <span className="relative flex h-2.5 w-2.5" data-id="element-111" data-mp="dbnnvjzcp2ay">
                    <span className="absolute inline-flex h-full w-full rounded-full opacity-75 animate-ping" style={{
              backgroundColor: '#D4A574'
            }} data-id="element-112" data-mp="9aty0l2cldff" />
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5" style={{
              backgroundColor: '#D4A574'
            }} data-id="element-113" data-mp="3vik1kpjhq8m0" />
                  </span>
                  {link.name}
                </Link> : <Link key={link.name} to={link.href} onClick={() => setIsOpen(false)} className={`block px-3 py-2 rounded-md text-base font-medium ${isActive(link.href) ? 'bg-blue-50 text-[#1E88E5]' : 'text-gray-600 hover:bg-gray-50 hover:text-[#1E88E5]'}`} data-id="element-114" data-mp="2kwcnaak8evay">
                  {link.name}
                </Link>)}

            <div className="px-3 py-2 mt-2" data-id="element-115" data-mp="261g2kxv8kfgz">
              <Link to="/donate" onClick={() => setIsOpen(false)} data-id="element-116" data-mp="2627rxqy8pgyt">
                <Button variant="primary" className="w-full gap-2 justify-center" data-id="element-117" data-mp="19hz2xfoosxzo">
                  <Heart className="w-4 h-4" data-id="element-118" data-mp="1diiyietm3tjp" />
                  Faire un don
                </Button>
              </Link>
            </div>
          </div>
        </div>}
    </nav>;
}